/** Parse the complete credential copied from Higgsfield; never echo it in errors. */
export function parseHiggsfieldKey(value: string): { key_id: string; key_secret: string } {
  const parts = value.trim().replace(/^Key\s+/i, '').split(':');
  if (parts.length !== 2 || parts.some((part) => !part.trim() || /\s/.test(part.trim()))) {
    throw new Error('Copy the complete API key from Higgsfield. It must contain both parts separated by a colon.');
  }
  return { key_id: parts[0].trim(), key_secret: parts[1].trim() };
}
